/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ws (ignored)
// module id = 4
// module chunks = 1